import React from 'react';
import { Link } from 'gatsby';
import { Col } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUndo,
  faPuzzlePiece,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

const AboutHeader = () => (
  <header className='bg-secondary mb-4 shadow-sm w-100'>
    <nav className='navbar-quiz d-flex justify-content-evenly align-items-center px-4 text-center'>
      <Col className='mt-3 text-center'>
        <Link to='/' className='text-decoration-none'>
          <FontAwesomeIcon icon={faUndo} className='text-black' />
          <p className='text-black'>back</p>
        </Link>
      </Col>
      <Col className='mt-3 text-center'>
        <Link className='text-decoration-none' to='/app/quiz'>
          <FontAwesomeIcon icon={faPuzzlePiece} className='text-black' />
          <p className='text-black'>quiz</p>
        </Link>
      </Col>
      <Col className='mt-3 text-center'>
        <Link className='text-decoration-none' to='/team'>
          <FontAwesomeIcon icon={faUsers} className='text-black' />
          <p className='text-black'>team</p>
        </Link>
      </Col>
    </nav>
  </header>
);

export default AboutHeader;
